import * as lpsrp from "../components/lpsrp"
import * as productBlocks from "../components/product-blocks";

export default function lp(model, uxview, sellerId) {
	// LPSRP 공통영역 초기화
    lpsrp.initialize(model,uxview, sellerId)
   
	// 대 카테고리 선택 영역 가운데로 이동
	lpsrp.setSelectedCategoryToMiddleScroll(document.querySelector(".box__list-wrap .item__category.active"), document.querySelector(".box__list-wrap .box__list"), document.querySelector(".box__lp-category .button__category-all"))

	// 중 카테도리 선택 영역 가운데로 이동
    lpsrp.setSelectedCategoryToMiddleScroll(document.querySelector(".box__sub-list-wrap .item__category.active"), document.querySelector(".box__sub-list-wrap .box__sub-list"), null)
    
    // 좋아요 버튼 등등
    productBlocks.initialize();
}



// WEBPACK FOOTER //
// ./src/pages/lp.js